module.exports = __webpack_public_path__ + "static/media/icon_microphone_b.e3730bb1.svg";